import React from "react";
import Counter from "../../components/Counter";

import shapeImg1 from "../../assets/img/funfact/shape-4-1.png";
import shapeImg2 from "../../assets/img/funfact/shape-4-2.png";

const FunFact = () => {
  const counters = [
    {
      countNum: 50,
      countSubtext: "+",
      countTitle: "Expert Doctors",
    },
    {
      countNum: 500000,
      countSubtext: "+",
      countTitle: "Happy Patients",
    },
    {
      countNum: 30,
      countSubtext: "+",
      countTitle: "Health Departments",
    },
    {
      countNum: 3,
      countSubtext: "+",
      countTitle: "Total Branches",
    },
  ];

  return (
    <div className="it-funfact-area  fix z-index-3">
      <div className="container">
        <div className="it-funfact-wrapper green-bg z-index p-relative">
          <div className="it-funfact-shape-1">
            <img src={shapeImg1} alt="" />
          </div>
          <div className="it-funfact-shape-2">
            <img src={shapeImg2} alt="" />
          </div>
          <div className="row">
            <div className="col-12">
              <div className="it-funfact-item-box flex-wrap text-center d-md-flex align-content-center justify-content-md-between">
                {counters.map((counter, index) => (
                  <div key={index} className="it-funfact-item border-style-1">
                    <h5 className="it-funfact-number">
                      <Counter start={0} end={counter.countNum} duration={3} counterSubText={counter.countSubtext} />
                    </h5>
                    <span className="it-funfact-title">{counter.countTitle}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FunFact;
